import { useEffect } from "react";

const useDocumentTitle = (title) => {
  const WEB_PAGE_NAME = " - Rulebook Company";

  useEffect(() => {
    document.title = title + WEB_PAGE_NAME;

    return () => {
      document.title = "Rulebook Company";
    };
  }, [title]); // This will update the title whenever the 'title' prop changes
};

export default useDocumentTitle;
